import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=26a29aab&"
import script from "./Leads.vue?vue&type=script&lang=js&"
export * from "./Leads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports